<template>
  <div>
    <div class="flex-100 px-2 mb-3" v-show="!reportHeader.meldeanlass">
      <fake-input-frame :label="$t('COMPONENT_REPORT.REPORT_CAUSE')"
                        :disabled="isDisabled">
        <div class="layout-row px-4 pb-2 flex layout-align-start-center">
          <label class="mr-8" :style="{'color': isDisabled  ? '#BDBDBD' : compColor.isInDarkMode ? '#cfd8dc' : '#455a64', 'font-size': denseFields ? '0.9em' : '16px'}">
            {{ $t('FORMS_DIVERSE.MODULE_SYST_THERAPY_QUESTION_REPORT_REASON') }}</label>

          <validation-provider tag="div"
                               :name="path + '.syst_ende_therapie'"
                               :ref="path + '.syst_ende_therapie'"
                               rules=""
                               class="layout-row"
                               v-slot="{ errors }">
            <v-radio-group :dense="denseFields" v-model="model.syst_ende_therapie" row hide-details :error-messages="errors[0]"
                           class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_BEGINN_OF_THERAPY')"
                       value="N" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_END_OF_THERAPY')"
                       value="J" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
            </v-radio-group>
          </validation-provider>
        </div>
      </fake-input-frame>
    </div>

    <!-- Ende der Therapie -->

    <div class="flex-100 px-2 mb-6" v-if="reportHeader.meldeanlass === 'behandlungsende'">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_END_OF_THERAPY')"
                        :disabled="isDisabled">
        <div class="layout-column px-4 pb-2 pt-2 flex">
          <div class="layout-row layout-wrap mt-2">

            <!-- Datum Ende -->

            <div class="flex-gt-sm-50 flex-100 pr-2">
              <validation-provider tag="div"
                                   :name="path + '.syst_ende_datum'"
                                   :ref="path + '.syst_ende_datum'"
                                   :rules="{german_date:true,date_not_in_future:true,date_must_be_greater_than:model.syst_beginn_datum,required:true,date_must_be_greater_than_diagnosis:diagDate,date_must_be_lesser_than_death:[deathDate, null]}"
                                   v-slot="{ errors }">
                <lx-datepicker
                  :color="compColor.textInput"
                  :auto-focus="!id"
                  :name="path + '.syst_ende_datum'"
                  :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_END_DATE') + ' *'"
                  :dense="denseFields"
                  :disabled="isDisabled"
                  @input="validateDependingFields(model.syst_ende_datum)"
                  :hide-details="!errors || errors.length <= 0"
                  :error="errors[0]"
                  v-model="model.syst_ende_datum"
                ></lx-datepicker>
              </validation-provider>
            </div>

            <!-- Grund Ende -->

            <div class="flex-gt-sm-50 flex-100 pl-2">
              <validation-provider tag="div"
                                   :name="path + '.syst_ende_grund'"
                                   :ref="path + '.syst_ende_grund'"
                                   rules="required"
                                   v-slot="{ errors }">
                <v-select
                  :color="compColor.primeColor"
                  :label="$t('FORMS_DIVERSE.MODULE_SYST_REASON_FOR_END') + ' *'"
                  v-model="model.syst_ende_grund"
                  :items="SYST_Ende_GrundTypes"
                  outlined
                  :disabled="isDisabled"
                  :dense="denseFields"
                  :hide-details="!errors || errors.length <= 0"
                  :error-messages="errors[0]"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>
          </div>
        </div>
      </fake-input-frame>
    </div>

    <!-- Beginn der Therapie -->

    <div class="flex-100 px-2 mb-6" v-if="!!reportHeader.meldeanlass">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_BEGINN_OF_THERAPY')"
                        :disabled="isDisabled">
        <div class="layout-row px-4 py-2 layout-wrap">

          <!-- Soll verlinkt werden ? -->

          <div class="flex-100 mb-2 layout-row" v-if="model.syst_ende_therapie === 'J'">
            <v-radio-group :dense="denseFields" v-model="isLinkedTherapy" row hide-details
                           class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_SYST_LABEL_END_THERAPY_LINK')"
                       value="J" :disabled="isDisabled || listOfUnlinkedTherapies.length === 0" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_SYST_LABEL_END_THERAPY_MANUALLY_INPUT')"
                       @change="unlinkTherapy"
                       value="N" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
            </v-radio-group>
          </div>

          <!-- Therapiebeginn Datum -->

          <div class="flex-gt-sm-50 flex-100 pr-2 mt-2" v-show="reportHeader.meldeanlass === 'behandlungsbeginn' || isLinkedTherapy === 'N'">
            <validation-provider tag="div"
                                 :name="path + '.syst_beginn_datum'"
                                 :ref="path + '.syst_beginn_datum'"
                                 :rules="{required:!!(reportHeader.meldeanlass==='behandlungsbeginn'||isLinkedTherapy==='N'),german_date:true,date_not_in_future:true,date_must_be_lesser_than:model.syst_ende_datum,date_must_be_greater_than_diagnosis:diagDate,date_must_be_lesser_than_death: [deathDate,model.syst_beginn_datum_genauigkeit]}"
                                 v-slot="{ errors }">
              <lx-datepicker
                :color="compColor.textInput"
                :auto-focus="!id && reportHeader.meldeanlass === 'behandlungsbeginn'"
                :name="path + '.syst_beginn_datum'"
                :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_START_DATE') + ' *'"
                class="mb-4"
                @input="checkDateAlreadyExists()"
                :dense="denseFields"
                :disabled="isDisabled || (!!model.linked_therapy && reportHeader.meldeanlass === 'behandlungsbeginn')"
                :error="errors[0]"
                :hide-details="!errors || errors.length <= 0"
                v-model="model.syst_beginn_datum"
              ></lx-datepicker>
            </validation-provider>
          </div>

          <!-- Verlinkter Therapiebeginn -->

          <div class="flex-gt-sm-50 flex-100 pr-2 mt-2" v-show="isLinkedTherapy === 'J'">
            <validation-provider tag="div"
                                 :name="path + '.linked_therapy'"
                                 :ref="path + '.linked_therapy'"
                                 :rules="{required: isLinkedTherapy === 'J'}"
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_LINKED_THERAPY') + ' *'"
                v-model="linkedId"
                :items="listOfUnlinkedTherapies"
                outlined
                :item-text="formatDateOfSystemicTherapy"
                @change="openLinkDialog"
                item-value="_id"
                :disabled="isDisabled"
                :hide-details="!errors || errors.length <= 0"
                :dense="denseFields"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ formatDateOfSystemicTherapy(item) }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>

          <!-- Datumsgenauigkeit Therapiebeginn Datum -->

          <div class="flex-gt-sm-50 flex-100 px-2 mt-2 layout-row">
            <validation-provider tag="div"
                                 class="flex"
                                 :name="path + '.syst_beginn_datum_genauigkeit'"
                                 :ref="path + '.syst_beginn_datum_genauigkeit'"
                                 rules="required"
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_START_DATE_ACCURACY') + ' *'"
                v-model="model.syst_beginn_datum_genauigkeit"
                :items="DateAccuracyTypes"
                :disabled="isDisabled"
                outlined
                @change="validateDateAfterChangeOfAccuracy()"
                :hide-details="!errors || errors.length <= 0"
                :dense="denseFields"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ item.text }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>

            <v-tooltip bottom open-delay="1000">
              <template v-slot:activator="{ on }">
                <div v-on="on" class="blue--text text--lighten-1 layout-row layout-align-start-start pt-2 ml-3"
                     :class="{'mt-1': !denseFields}"
                     style="cursor: pointer;">
                  <v-icon :color="compColor.prime" medium>info</v-icon>
                </div>
              </template>
              <p style="max-width: 400px;" class="my-1">{{ $t('FORMS_DIVERSE.TOOLTIP_DATE_ACCURACY') }}</p>
            </v-tooltip>
          </div>

          <!-- Info wenn Therapiebeginn ist verlinkt mit Therapieende -->

          <div v-if="!!model.linked_therapy && model.linked_therapy !== '000000000000000000000000' && reportHeader.meldeanlass === 'behandlungsbeginn' && model.syst_ende_therapie !== 'J'"
               class="flex-gt-sm-100 mb-2 pa-3 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
               :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
               :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
            <div class="layout-column layout-align-center-center mr-3">
              <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
            </div>
            <span style="font-size: 14px;" v-bind:class="compColor.primeClass">{{ $t('FORMS_DIVERSE.MODULE_SYST_THERAPY_LINKED_THERAPY_MESSAGE') }}</span>
          </div>

          <!-- Warnung wenn Beginn Datum schon an anderer Therapie mit Behandlungsbeginn existiert -->

          <div v-if="showWarningOfStartDate" class="flex-gt-sm-100 mb-3 pa-3 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
               :class="[!compColor.isInDarkMode ? allColors['deep-orange'].prime + ' lighten-5 white--text ' : '']"
               :style="{'border-color': compColor.isInDarkMode ? allColors['deep-orange'].primeHighlightColor : 'transparent'}">
            <div class="layout-column layout-align-center-center mr-3">
              <v-icon size="30" :color="allColors['deep-orange'].prime">warning</v-icon>
            </div>
            <span style="font-size: 14px;" v-bind:class="allColors['deep-orange'].primeClass">{{ $t('FORMS_DIVERSE.MODULE_SYST_THERAPY_START_DATE_WARNING') }}</span>
          </div>
        </div>
      </fake-input-frame>
    </div>

    <!-- Intention/Stellung zu operativer Therapie -->

    <div class="flex-100 px-2 mb-6" v-if="!!reportHeader.meldeanlass">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_INTENSION')"
                        :disabled="isDisabled">
        <div class="layout-row pa-2 layout-wrap">

          <!-- Message to Intention and Stellung zu operativer Therapie -->

          <div class="flex-gt-sm-100 ma-2 pa-3 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
               :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
               :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
            <div class="layout-column layout-align-center-center mr-3">
              <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
            </div>
            <span style="font-size: 14px;" v-bind:class="compColor.primeClass">{{ $t('FORMS_DIVERSE.BASE_SYSTEMIC_THERAPY_INTENTION_MESSAGE') }}</span>
          </div>

          <!-- Intention -->

          <div class="flex-gt-sm-50 flex-100 px-2 mt-4">
            <validation-provider tag="div"
                                 :name="path + '.syst_intention'"
                                 :ref="path + '.syst_intention'"
                                 rules="required"
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                :label="$t('FORMS_DIVERSE.MODULE_SYST_INTENTION') + ' *'"
                v-model="model.syst_intention"
                :items="SYST_IntentionTypes"
                outlined
                :disabled="isDisabled"
                :dense="denseFields"
                :hide-details="!errors || errors.length <= 0"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ item.text }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>

          <!-- Stellung zu operativer Therapie -->

          <div class="flex-gt-sm-50 flex-100 px-2 mt-4">
            <validation-provider tag="div"
                                 :name="path + '.syst_stellung_op'"
                                 :ref="path + '.syst_stellung_op'"
                                 rules="required"
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                :label="$t('FORMS_DIVERSE.MODULE_SYST_POSITION_TO_OP') + ' *'"
                v-model="model.syst_stellung_op"
                :items="SYST_Stellung_OPTypes"
                outlined
                :disabled="isDisabled"
                :dense="denseFields"
                :hide-details="!errors || errors.length <= 0"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ item.text }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>
        </div>
      </fake-input-frame>
    </div>

    <!-- Protokoll / Wirkstoffe -->

    <div class="flex-100 px-2 mb-6" v-if="!!reportHeader.meldeanlass">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_AGENTS')"
                        :disabled="isDisabled">
        <div class="layout-row layout-wrap px-4">

          <!-- Protokoll -->

          <div class="flex-gt-sm-50 flex-100 my-4">
            <validation-provider tag="div"
                                 :name="path + '.syst_protokoll'"
                                 :ref="path + '.syst_protokoll'"
                                 rules="trim_string"
                                 v-slot="{ errors }">
              <lx-autocomplete
                :label="$t('FORMS_DIVERSE.MODULE_SYST_PROTOCOL')"
                v-model="model.syst_protokoll"
                :error="errors[0]"
                @search-method="getProtocolForAutocomplete"
                @input="setProtocol"
                :disabled="isDisabled || model.syst_no_agent"
                :dense="denseFields"
                :hide-details="!errors || errors.length <= 0"
                :results="resultSearchProtocolModel">
                <template v-slot="slotProps">
                  <div class="layout-row">
                    <div style="width: 250px;border-radius: 4px;"
                         class="mr-2 px-2 white lighten-2 layout-column layout-align-center-center">
                      <h4>
                        <lx-text-highlight :text="slotProps.lineItem.protocol"
                                           :search-string="slotProps.searchText"
                                           :color="compColor.prime"></lx-text-highlight>
                      </h4>
                    </div>
                    <div class="flex">
                      <span class="body-2">
                        <lx-text-highlight :text="setTextForAgentsInList(slotProps.lineItem.agents)"
                                           :search-string="slotProps.searchText"
                                           :color="compColor.prime"></lx-text-highlight>
                      </span>
                    </div>
                  </div>
                </template>
              </lx-autocomplete>
            </validation-provider>
          </div>

          <div class="flex-gt-sm-50 flex-100"></div>

          <!-- Wirkstoffe -->

          <div class="flex-gt-sm-100 flex-100 mt-1">
            <!-- hidden input field to show error, if array of agents is empty -->
            <validation-provider tag="div"
                                 :name="path + '.syst_substanz'"
                                 :ref="path + '.syst_substanz'"
                                 :rules="{ at_least_one_agent_is_selected: [model.syst_no_agent, kindOfTherapyIsPassive] }"
                                 v-slot="{ errors }">
              <lx-alert-box v-show="errors[0]" color="red" class="my-2">
                {{ $t('ERROR_EMPTY_AGENTS_ARRAY') }}
              </lx-alert-box>

              <v-text-field
                v-model="model.syst_substanz"
                v-show="false"
                :dense="denseFields"
                outlined
                hide-details
                :disabled="isDisabled"
                :error-messages="errors[0]"
              ></v-text-field>
            </validation-provider>
          </div>

          <div class="layout-column flex-gt-sm-100 flex-100 mb-4">
            <div v-bind:style="{'z-index': '4'}" class="layout-align-start-center layout-row pb-1 pt-0">
              <lx-btn :disabled="isDisabled || therapiesWithoutAgents.indexOf(model.syst_therapieart) > -1 || model.syst_no_agent"
                      icon="add_circle"
                      :color="compColor.primeColor"
                      :iconColor="'white'"
                      :tooltip="$t('FORMS_DIVERSE.MODULE_SYST_ADD_NEW_THERAPY_AGENT')"
                      :label="$t('FORMS_DIVERSE.MODULE_SYST_ADD_NEW_THERAPY_AGENT')"
                      iconSize="21"
                      :width="'auto'"
                      :height="35"
                      classes="text-none mb-1"
                      @click="addAgent()"
              ></lx-btn>

              <v-checkbox :dark="compColor.isInDarkMode"
                          :color="compColor.primeColor"
                          hide-details
                          :label="$t('FORMS_DIVERSE.MODULE_SYST_NO_AGENT')"
                          class="ml-5 mt-0 mb-1"
                          @change="resetNoAgents(model.syst_no_agent)"
                          v-model="model.syst_no_agent"
                          :disabled="isDisabled">
              </v-checkbox>
            </div>

            <div v-for="(item, index) in model.syst_substanz"
                 :key="index"
                 class="layout-row pa-0 my-1"
                 :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
                 style="border-radius:4px;"
                 :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

              <div class="layout-row layout-wrap flex px-3">
                <div class="flex-gt-sm-50 flex-100 px-2 py-3">
                  <validation-provider tag="div"
                                       :name="path + '.syst_substanz.' + index + '.bezeichnung'"
                                       :ref="path + '.syst_substanz.' + index + '.bezeichnung'"
                                       :rules="{agent_must_be_unique: [model.syst_substanz], required: true, trim_string: true}"
                                       v-slot="{ errors }">
                    <lx-autocomplete
                      :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_AGENT') + ' *'"
                      v-model="item.bezeichnung"
                      :error="errors[0]"
                      @search-method="getDataForAutocomplete"
                      @input="setAgent"
                      :length="3"
                      :disabled="isDisabled"
                      :dense="denseFields"
                      :hide-details="!errors || errors.length <= 0"
                      :index="index"
                      :results="resultSearchModel">
                      <template v-slot="slotProps">
                        <div class="layout-row">
                          <div style="width: 300px;border-radius: 4px; word-wrap: normal;"
                               class="mr-2 px-2 white lighten-2 layout-column layout-align-center-start">
                            <h3>
                              <lx-text-highlight :text="slotProps.lineItem.Name_deutsch || ''"
                                                 :search-string="slotProps.searchText"
                                                 :color="compColor.prime"></lx-text-highlight>
                            </h3>
                          </div>
                          <div class="flex">
                          <span class="body-2">
                            <lx-text-highlight :text="slotProps.lineItem.Key_ATC || ''" :search-string="slotProps.searchText"
                                               :color="compColor.prime"></lx-text-highlight>
                          </span>
                          </div>
                        </div>
                      </template>
                    </lx-autocomplete>
                  </validation-provider>
                </div>

                <div class="flex-gt-sm-50 flex-100 px-2 py-3" v-if="item.atc">
                  <validation-provider tag="div"
                                       class="layout-column"
                                       :name="path + '.syst_substanz.' + index + '.atc.code'"
                                       :ref="path + '.syst_substanz.' + index + '.atc.code'"
                                       rules=""
                                       v-slot="{ errors }">
                    <v-text-field
                      label="ATC-Code"
                      v-model="item.atc.code"
                      :dense="denseFields"
                      outlined
                      class="ma-0"
                      hide-details
                      disabled
                      :dark="compColor.isInDarkMode"
                      :error-messages="errors[0]"
                    ></v-text-field>

                    <!-- Render error separately to be able to see it, when field is disabled -->
                    <div v-if="errors[0]" class="layout-row layout-align-start-center mt-1 ml-2">
                      <span class="error--text" style="font-size: 12px;">{{ errors[0] }}</span>
                    </div>
                  </validation-provider>
                </div>
              </div>

              <div class="layout-column layout-align-center-center px-3"
                   :class="{'grey lighten-2': !compColor.isInDarkMode}"
                   :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">
                <lx-btn @click="deleteAgent(model.syst_substanz, index, path + '.syst_substanz.' + index + '.bezeichnung')"
                        :color="compColor.primeColor"
                        :iconColor="'white'"
                        iconSize="21"
                        :width="35"
                        :height="35"
                        :disabled="isDisabled || model.syst_substanz.length === 1"
                        icon="delete_forever"></lx-btn>
              </div>
            </div>
          </div>
        </div>
      </fake-input-frame>
    </div>

    <!-- Therapieart -->

    <div class="flex-100 px-2 mb-2" v-if="!!reportHeader.meldeanlass">
      <validation-provider tag="div"
                           :name="path + '.syst_therapieart'"
                           :ref="path + '.syst_therapieart'"
                           rules="required"
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_KIND_OF_THERAPY') + ' *'"
          v-model="model.syst_therapieart"
          :items="selectionForKindOfTherapy"
          outlined
          @change="clearProtocol(model.syst_therapieart)"
          :disabled="isDisabled"
          :dense="denseFields"
          :hide-details="!errors || errors.length <= 0"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>

      <!-- Info wenn Protokoll vorhanden und Therapieart disabled ist -->

      <div v-if="!!model.syst_protokoll && !!model.syst_therapieart" class="flex-gt-sm-100 mb-2 pa-3 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
           :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
           :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
        <div class="layout-column layout-align-center-center mr-3">
          <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
        </div>
        <span style="font-size: 14px;" v-bind:class="compColor.primeClass">{{ $t('FORMS_DIVERSE.MODULE_SYST_THERAPY_PROTOCOL_EXISTS_MESSAGE') }}</span>
      </div>

      <!-- Info wenn Wirkstoffe aber keine Applikationsart vorhanden -->

      <div v-if="model.syst_substanz && model.syst_substanz.length > 0  && !model.syst_therapieart" class="flex-gt-sm-100 mb-2 pa-3 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
           :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
           :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
        <div class="layout-column layout-align-center-center mr-3">
          <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
        </div>
        <span style="font-size: 14px;" v-bind:class="compColor.primeClass">{{ $t('FORMS_DIVERSE.MODULE_SYST_THERAPY_NO_KIND_OF_THERAPY_MESSAGE') }}</span>
      </div>
    </div>

    <link-dialog
      title="FORMS_DIVERSE.MODULE_SYST_TAKE_OVER_POPUP_HEADER"
      message="FORMS_DIVERSE.MODULE_SYST_TAKE_OVER_POPUP_TEXT"
      :showLinkDialog="showLinkDialog"
      :isLoading="isLoading || updateIsRunning"
      @set-show-link-dialog="setLinkedBaseData"
      @close-link-dialog="closeLinkDialog">
    </link-dialog>
  </div>
</template>

<script>
import metaData from '../shared/formsMetaData'
import utils from '../../../common/utils'
import LxAutocomplete from '../../lx_auto_complete/LxAutocomplete'
import LxTextHighlight from '../../lx_text_highlighter/LxTextHighlight'
import lodash from 'lodash'

import LinkDialog from './LinkConfirmDialog'

export default {
  name: "GrunddatenSystTherapie",
  mixins: [metaData, utils],
  components: {
    LxAutocomplete,
    LxTextHighlight,
    LinkDialog
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    path: {
      type: String
    },
    id: {
      type: String
    },
    addAgentsItem: {
      type: Function
    },
    deleteAgentsItem: {
      type: Function
    },
    isDisabled: {
      type: Boolean
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    reportHeader: {
      type: Object,
      default: () => ({})
    },
    patientId: {
      type: String
    },
    reloadUnlinkedTherapies: {
      type: Boolean,
      default: false
    },
    isLoading: Boolean
  },
  data() {
    return {
      model: {},
      resultSearchModel: {},
      resultSearchProtocolModel: {},
      SYST_IntentionTypes: null,
      SYST_Stellung_OPTypes: null,
      SYST_Ende_GrundTypes: null,
      SYST_TherapyArtTypes: null,
      oldProtocolData: {},
      showWarningOfStartDate: false,
      listOfUnlinkedTherapies: [],
      DateAccuracyTypes: null,
      isLinkedTherapy: 'N',
      therapiesWithoutAgents: ['SZ', 'WS', 'AS', 'WW'],
      therapiesWithoutAgentsList: [],
      linkedId: null,
      showLinkDialog: false,
      updateIsRunning: false
    }
  },
  created() {
    this.SYST_IntentionTypes = this.formsMetaData.SYST_IntentionTypes
    this.SYST_Stellung_OPTypes = this.formsMetaData.SYST_Stellung_OPTypes
    this.SYST_Ende_GrundTypes = this.formsMetaData.SYST_Ende_GrundTypes
    this.SYST_TherapyArtTypes = this.formsMetaData.SYST_TherapyArtTypes
    this.therapiesWithoutAgentsList = this.formsMetaData.SYST_Passive_TherapyArtTypes
    this.DateAccuracyTypes = this.formsMetaData.DateAccuracyShort
  },
  methods: {
    /**
     * Validate date after changing date accuracy
     */
    validateDateAfterChangeOfAccuracy() {
      this.$nextTick(() => {
        if (this.$refs[this.path + '.syst_beginn_datum']) {
          this.$refs[this.path + '.syst_beginn_datum'].validate()
        }
      })
    },

    /**
     * Show warning, if start date already exists in other therapy
     *
     * @param isInitial Is true after changing form
     */
    checkDateAlreadyExists(isInitial) {
      // give validation time to validate and set correct valid-flag
      setTimeout(() => {
        // check if start date already exists in other therapy only when selected date is valid date value and report reason is not "behandlungsende"
        if (this.$refs[this.path + '.syst_beginn_datum']?.flags && this.$refs[this.path + '.syst_beginn_datum']?.flags.valid && this.reportHeader.meldeanlass === 'behandlungsbeginn' && this.model.syst_ende_therapie !== 'J') {
          // "syst_beginn_datum" can only be a ISO-string, a timestamp or a date value if it is a valid value
          const date = typeof this.model.syst_beginn_datum !== 'string' ? this.model.syst_beginn_datum.toISOString() : this.model.syst_beginn_datum

          const query = {
            currentId: this.id,
            patientId: this.patientId,
            date: date
          }

          this.$http.get('/documentation/checkSystemicTherapyWithSameStartDate?config=' + JSON.stringify(query))
            .then(res => {
              if (res.data) {
                this.showWarningOfStartDate = res.data.exists
              }
            })
        } else {
          this.showWarningOfStartDate = false
        }
      }, 0)

      // set syst_beginn_datum_genauigkeit if not exists after changing syst_beginn_datum in datepicker
      if (!isInitial && this.model.syst_beginn_datum && !this.model.syst_beginn_datum_genauigkeit) {
        this.$set(this.model, 'syst_beginn_datum_genauigkeit', 'E')
      }
    },

    /**
     * Load unlinked therapies, when end of therapy is triggered or form with "behandlungsende" is loaded
     * Unlinked therapies are elements of list to link
     */
    getUnlinkedTherapies() {
      // set list of unlinked therapies on default
      this.listOfUnlinkedTherapies = []

      if (this.model.syst_ende_therapie === 'J' || this.model.syst_ende_datum) {
        const config = {
          patientId: this.patientId,
          formId: this.id,
          subjId: this.subjId
        }

        this.$http.get('/documentation/getUnlinkedBeginTherapies/systemicTherapy?config=' + JSON.stringify(config))
          .then(res => {
            if (res.data) {
              // add found therapies to default list
              this.listOfUnlinkedTherapies = res.data
            }
          })
      }
    },

    /**
     * Delete linked therapy, when start date should be set manually and trigger save
     */
    unlinkTherapy() {
      this.linkedId = null
      this.$delete(this.model, 'linked_therapy')
      this.validationRef.fields['base.linked_therapy'].changed = true
    },

    /**
     * Open dialog to decide, if all base data of linked therapy should be overtaken
     */
    openLinkDialog() {
      this.updateIsRunning = true
      this.showLinkDialog = true
    },

    /**
     * Close link dialog
     */
    closeLinkDialog() {
      this.showLinkDialog = false
    },

    /**
     *  Set base data in dependency to selected parameter (all or only start date)
     *
     * @param parameter The selected kind of overtaking data
     */
    setLinkedBaseData(parameter) {
      if (this.linkedId) {
        // copy all base data from selected start therapy
        if (parameter === 'all') {

          // load data of linked therapy and set base values
          this.$http.get('/documentation/forms/' + this.linkedId)
            .then(res => {
              if (res.data?.form && res.data.form.base) {
                this.$set(this.model, 'linked_therapy', this.linkedId)
                this.$set(this.model, 'syst_intention', res.data.form.base.syst_intention)
                this.$set(this.model, 'syst_stellung_op', res.data.form.base.syst_stellung_op)
                this.$set(this.model, 'syst_protokoll', res.data.form.base.syst_protokoll)
                this.$set(this.model, 'syst_substanz', res.data.form.base.syst_substanz)
                this.$set(this.model, 'syst_therapieart', res.data.form.base.syst_therapieart)
                this.$set(this.model, 'syst_no_agent', res.data.form.base.syst_no_agent)
                this.$set(this.model, 'syst_beginn_datum', res.data.form.base.syst_beginn_datum)
                this.$set(this.model, 'syst_beginn_datum_genauigkeit', res.data.form.base.syst_beginn_datum_genauigkeit)

                // update base data and linked id separately, because of updating model in Formdetails took too long, if slow internet connection
                if (this.id) {
                  const dataObject = {
                    id: this.id,
                    systemicTherapy: this.model
                  }

                  this.$http.put('/documentation/updateDataAfterLinkingTherapy', dataObject)
                    .then((res) => {
                      this.updateIsRunning = false

                      this.NotifySuccess(res, this.$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_UPDATE_NOTIFICATION'))

                      // trigger get Data to show correct content of systemic therapy and trigger getMultiForms
                      // when not called, view may not show correct content
                      this.$emit('trigger-get-data')
                    })
                    .catch((error) => {
                      this.updateIsRunning = false
                      this.NotifyError(error)
                    })
                }
              }
            })
        } else {
          // set only date of linked therapy
          const linkedDate = this.listOfUnlinkedTherapies.find(therapy => this.linkedId === therapy._id).date
          this.$set(this.model, 'syst_beginn_datum', linkedDate)
          // set validator-flag to dirty to trigger auto-save
          this.validationRef.fields['base.syst_beginn_datum'].changed = true

          this.linkedId = null
          this.showLinkDialog = false
        }
      }
    },

    /**
     * set required-state in dependency to agents-array and kind of therapies
     */
    atLeastOneAgentIsSelected() {
      let agentsList = lodash.cloneDeep(this.model.syst_substanz)
      agentsList = agentsList || []
      // agents-array is invalid if empty or the first and only element is an empty element
      const invalidAgentsArray = agentsList.length === 0 || (agentsList.length === 1 && !agentsList[0].bezeichnung)

      return invalidAgentsArray && this.model.syst_therapieart && this.therapiesWithoutAgents.indexOf(this.model.syst_therapieart) === -1
    },

    /**
     * Reset agents, protocol and kind of therapy after clicking checkbox of no agent
     */
    resetNoAgents(value) {
      if (value) {
        delete this.model.syst_protokoll
        delete this.model.syst_substanz
      }

      // delete kind of therapy only, if it is an active therapy (if syst_no_agent is true)
      // delete also if syst_no_agent is unset (passive therapy will be deleted)
      if ((this.therapiesWithoutAgents.indexOf(this.model.syst_therapieart) === -1 && value) || !value) {
        this.$delete(this.model, 'syst_therapieart')
      }

      this.validationRef.fields[this.path + '.syst_protokoll'].changed = true
    },

    /**
     * Add empty agent to agent array after clicking 'add'
     */
    addAgent() {
      this.$set(this.model, 'syst_no_agent', false)

      if (!this.model.syst_substanz) {
        this.$set(this.model, 'syst_substanz', [])
      }
      this.$set(this.model.syst_substanz, this.model.syst_substanz.length, {})

      this.validationRef.fields[this.path + '.syst_substanz'].changed = true
    },

    /**
     * Delete agent from agent array
     *
     * @param value The array
     * @param index The index of array
     * @param field The validator field
     */
    deleteAgent(value, index, field) {
      this.$delete(value, index)
      this.validationRef.fields[field].changed = true
    },

    /**
     * Get list of agents as result of search
     */
    getDataForAutocomplete(data, index) {
      // clear string from special characters to provide errors
      data = this.clearStringForRegexSearch(data)

      // prevent search, when search string has less than 3 letters after clearing
      if (data.length < 3) return

      // reset resultModel to display the correct results after db-request
      this.resultSearchModel = {}

      this.$http.get('/agents/search?config={"opts":{}, "query": {"searchValue":"' + data + '"}}')
        .then(res => {
          // give index of selected array-element to component to ensure, that only popup of selected element will be opened and not all
          res.data.index = index
          this.resultSearchModel = res.data
        })
        .catch(this.NotifyError)
    },

    /**
     * Set agent from list of auto-complete
     *
     * @param data
     * @param index
     */
    setAgent(data, index) {
      if (data && data.Name_deutsch) {
        const agent = {
          bezeichnung: data.Name_deutsch
        }

        // set atc-values, if atc-code exists in selected item from list
        if (data.Key_ATC) {
          agent.atc = {
            code: data.Key_ATC,
            version: new Date().getFullYear().toString()
          }
        }

        this.$set(this.model.syst_substanz, index, agent)

        // protocol data must not be changed in kind of protocol, if exists
        if (!this.model.syst_protokoll) {
          let agentsList = ''
          this.model.syst_substanz.forEach((agent, index) => {
            if (index > 0) {
              agentsList += ',' + agent.bezeichnung
            } else {
              agentsList += agent.bezeichnung
            }
          })

          // Get therapy types for 'model.syst_substanz'
          this.$http.get('/agents/therapyTypes/' + agentsList)
            .then((res) => {
              if (res.data && (res.data.type || res.data.type === '')) {
                this.$set(this.model, 'syst_therapieart', res.data.type || null)

                this.$nextTick(() => {
                  // validate syst_therapieart separately after programmatic change
                  this.$refs[this.path + '.syst_therapieart'].validate()
                })
              }
            })
            .catch(this.NotifyError)
        }
      } else {
        this.$set(this.model.syst_substanz[index], 'bezeichnung', data)
        this.$set(this.model.syst_substanz[index], 'atc', null)
      }
    },

    /**
     * Get list of register protocols codes via regex in auto-complete
     *
     * @param data The Search string
     */
    getProtocolForAutocomplete(data) {
      // clear string from special characters to provide errors
      data = this.clearStringForRegexSearch(data)
      // reset resultModel to display the correct results after db-request
      this.resultSearchProtocolModel = {}

      this.$http.get('/protocols/search?config={"opts":{"limit": 30}, "query": {"searchValue":"' + data + '"}}')
        .then(res => {
          this.resultSearchProtocolModel = res.data
        })
        .catch(this.NotifyError)
    },

    /**
     * Create String of agents in list of protocols to show in list of auto complete
     *
     * @param agents Array of agents as string
     */
    setTextForAgentsInList(agents) {
      agents = agents || []
      const length = agents.length
      let returnValue = length > 0 ? 'Wirkstoffe: ' : 'Keine Wirkstoffe'

      agents.forEach((agent, index) => {
        returnValue += agent.bezeichnung
        if (index < length - 1) {
          returnValue += ', '
        }
      })

      return returnValue
    },

    /**
     * Set protocol value, agents, types via list from auto complete
     *
     * @param data The selected object of protocol
     */
    setProtocol(data) {
      // fill only values, if data is an object
      if (data && data.protocol) {
        this.$set(this.model, 'syst_therapieart', data.type)
        this.$set(this.model, 'syst_protokoll', data.protocol)
        this.$set(this.model, 'syst_substanz', data.agents)

        // set boolean of syst_no_agent in dependency to existing agents
        this.$set(this.model, 'syst_no_agent', !(data.agents && data.agents.length > 0))

        // set oldProtocolData with selected protocol to have chance to delete values
        // of agents and kind of therapies in form after deleting protocol
        this.oldProtocolData = lodash.cloneDeep(data)
      } else if (data !== this.oldProtocolData.protocol) {
        this.$delete(this.model, 'syst_therapieart')
        this.$delete(this.model, 'syst_substanz')

        this.oldProtocolData = {}
      }
    },

    /**
     * Clear protocol after changing kind of therapy
     *
     * @param kindOfTherapy
     */
    clearProtocol(kindOfTherapy) {
      // delete agents, if selected therapy ist a passive therapy
      if (this.therapiesWithoutAgents.indexOf(kindOfTherapy) > -1) {
        this.$delete(this.model, 'syst_protokoll')
        this.$delete(this.model, 'syst_substanz')
        this.$set(this.model, 'syst_no_agent', true)
      }
    },

    /**
     * Validate fields depending on end date of radiation
     */
    validateDependingFields(date) {
      // overwrite value only if there is no date or value is empty
      if (!this.model.syst_ende_grund || !date) {
        this.$set(this.model, 'syst_ende_grund', date ? 'E' : null)
      }
    }
  },
  computed: {
    kindOfTherapyIsPassive() {
      return this.model.syst_therapieart && this.therapiesWithoutAgents.indexOf(this.model.syst_therapieart) > -1
    },
    diagDate() {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).diagDate : undefined
    },
    deathDate() {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).deathDate : undefined
    },
    subjId() {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).subjId : undefined
    },
    selectionForKindOfTherapy() {
      return this.model.syst_no_agent ? this.therapiesWithoutAgentsList : this.SYST_TherapyArtTypes
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue || {}
          this.isLinkedTherapy = this.model.syst_ende_therapie === 'J' && this.model.linked_therapy ? 'J' : 'N'

          // set helper-property in dependency to existing linked therapy
          if (this.model.syst_ende_therapie === 'J' && this.model.linked_therapy) {
            this.linkedId = this.model.linked_therapy
          } else {
            this.linkedId = null
          }
        }
      },
      immediate: true
    },
    reloadUnlinkedTherapies: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue && newValue) {
          // load list of unlinked therapies after saving form with changed report reason
          this.getUnlinkedTherapies()
        }
      },
      immediate: true
    },
    id: {
      handler: function (newValue, oldValue) {
        // reset oldProtocolData when form has been changed
        this.oldProtocolData = {}
        this.showWarningOfStartDate = false
        this.isLinkedTherapy = this.model.syst_ende_therapie === 'J' && this.model.linked_therapy ? 'J' : 'N'

        if (newValue && newValue !== oldValue && this.model.syst_protokoll) {
          // load default values of selected protocol when initialize form
          this.$http.get('/protocols/search?config={"opts":{"limit": 30}, "query": {"name":"' + this.model.syst_protokoll + '"}}')
            .then(res => {
              if (res && res.data && res.data.result && res.data.result.length > 0) {
                this.oldProtocolData = res.data.result[0]
              }
            })
        }

        // show warning after loading form, when other therapy has same start-date and report reason is "behandlungsbeginn"
        if (this.model.syst_beginn_datum) {
          this.checkDateAlreadyExists(true)
        }

        // load list of unlinked therapies, if shown therapy has report reason "behandlungsende"
        this.getUnlinkedTherapies()
      },
      immediate: true
    }
  }
}
</script>

